module.exports = __webpack_public_path__ + "img/evanghelie-1769-pagina-ded-titlu-big.7ef8b474.jpg";